// Temporary local-storage gate for in-progress features: hidden from clients by default,
// while devs/testers opt in via a local-storage flag in their own browser. This is a
// development-time switch only — the actual client rollout is handled elsewhere (server
// flag / domain config), not by this toggle.
import {z as r} from 'zod';

import {getFromLocalStorage} from '../local-storage';

import {phrasesLocalStorageKey} from './feature-toggle-const';
import {FeatureToggleKeyType} from './feature-toggle-type';

function isFeatureEnabled(key: FeatureToggleKeyType): boolean {
    return getFromLocalStorage<boolean>(key, r.boolean().optional(), false);
}

export function isReviewPhrasesFeatureEnabled(): boolean {
    return isFeatureEnabled(phrasesLocalStorageKey);
}
